import { Link } from 'react-router-dom'

export const DesktopSubNav = ({
  subNav,
  isSubItemActive
}: {
  subNav: { href: string; title: string }[]
  isSubItemActive: (href: string) => boolean
}) => {
  if (!subNav?.length) return null

  return (
    <nav className="bg-wine-200 hidden lg:block h-[54px]">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="flex justify-center items-center h-full">
          <ul className="flex space-x-6 list-none">
            {subNav.map((item, i: number) => (
              <li key={i}>
                <Link
                  to={item.href}
                  className={`block px-3 py-3 text-sm font-satoshi uppercase ${
                    isSubItemActive(item.href)
                      ? 'text-white font-bold'
                      : 'text-white font-medium'
                  }`}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  )
}